(ns common.db.effects.localstorage
  (:require [clojure.spec.alpha :as spec]
            [common.localstorage :as localstorage]
            [re-frame.core :as rf]))

(rf/reg-fx :localstorage/save
  (fn [[k v]]
    (localstorage/save! k v)))

(rf/reg-fx :localstorage/remove
  (fn [[ks]]
    {:pre [(spec/assert (spec/or :set set? :seq sequential? :string string?) ks)]}
    (doseq [k (if ((some-fn sequential? set?) ks) ks [ks])]
      (localstorage/remove! k))))
